import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';
import { getUserPermissions } from '../../reducers';
import hasRequiredPermissions from '../has-required-permissions';

const mapStateToProps = state => ({
    userPermissions: getUserPermissions(state)
});

const bindState = connect(mapStateToProps);

const renderIfAllowed = (requiredPermissions, AltComponent) =>
    branch(
        ({ userPermissions }) =>
            !hasRequiredPermissions(requiredPermissions, userPermissions),
        renderComponent(AltComponent)
    );

export default (requiredPermissions, AltComponent = () => null) =>
    compose(bindState, renderIfAllowed(requiredPermissions, AltComponent));

//Example of including user permissions to see certain tasks
//Have to include the helpers/hocs/has-required-permissions.js file
//const btn = hasRequiredPermissions({Event: ["Reject", "CREATE"]})(() => <button>reject</button>)



// WEBPACK FOOTER //
// ./src/helpers/hocs/has-required-permissions.js